import { FC } from "react";
import { Content } from "@prismicio/client";
import { SliceComponentProps } from "@prismicio/react";
import StageHeader from "@/components/organisms/stage-header";
import { appLocales, Locales } from "@/lib/i18n";

export type HeroInterneProps = SliceComponentProps<Content.HeroInterneSlice> & {
  context?: { locale?: Locales };
};
const HeroInterne: FC<HeroInterneProps> = ({ slice, context }) => {
  const locale = context?.locale || appLocales.defaultLocale;
  const { title, description } = slice.primary;

  return (
    <section data-slice-type={slice.slice_type} data-slice-variation={slice.variation}>
      <StageHeader
        locale={locale}
        className="md:my-4 max-md:[&_h1]:mt-4"
        orientationOnMobile="center"
        hideDescriptionOnMobile
        title={title}
        description={description}
      />
    </section>
  );
};

export default HeroInterne;
